export default __webpack_public_path__ + "static/assets/35c3970891eb911f679b88252703b30c.png";